import React, { PureComponent } from 'react'
import Toggle from './toggle'

class ToggleForm extends PureComponent {

	render() {
		/*if(this.props.meta.error || this.props.error || this.props.input.error) {
			console.log('I HAVE RROR:', this.props)
		}*/
		//console.log(this.props)
		return <Toggle
			value={this.props.input.value}
			onChange={this.props.input.onChange}
		/>
	}
}

ToggleForm.defaultProps = {
}

export default ToggleForm
